import "../sass/styles.scss";
import Router from "../javascript/router";

const init = () => {
  const mobileMenuIcon = document.querySelector("#toggle-menu");
  const mobileMenu = document.querySelector(".site-navigation");
  if (!window.location.hash) {
    window.location.hash = "#/dashboard";
  }
  Router();
  mobileMenuIcon.addEventListener("click", (e) => {
    e.preventDefault();
    mobileMenu.classList.toggle("showing");
  });
};

document.addEventListener("DOMContentLoaded", init);
window.addEventListener("hashchange", Router);
